import React from 'react'
import { useTranslation } from 'react-i18next'
import { useRecoverPasswordEmail } from '../../../hooks/useUser'
import { useAllowedCountries } from '../../../hooks/useRoutes'
import { useInitUser } from '../../../hooks/useUser'
import { ControllerInput } from '../../shared/Input/ControllerInput'
import { Button } from '../../shared/simple/Button'
import { Label } from '../../shared/simple/Label'
import { LinkText } from '../../shared/simple/RouterLink'
import { FormProvider } from 'react-hook-form'
import SlideCaptchaModal from '../../shared/slide-captcha-modal/SlideCaptchaModal'
import { LoaderSpinner } from '../../shared/simple/LoaderSpinner'

const AltRecoverPassword = ({
  setStep
}) => {  
  
  const { allowed } = useAllowedCountries();
  const {
    isSlideModalOpen,
    loading,
    onSubmit,
    setIsSlideModalOpen,
    values
  } = useInitUser(allowed);
  const { errors, handleSubmit, onRecover, register, methods } = useRecoverPasswordEmail();

  const { t } = useTranslation()

  const altErrorMessageStyle = {
    display: 'block',
    color: '#FF7171',
    backgroundColor: 'rgba(255, 113, 113, 0.12)',
    borderLeft: '3px solid #FF7171',
    padding: '2px 8px',
    borderRadius: '6px',
    fontSize: '0.875em',
    fontWeight: 500,
    marginTop: '2px',
    marginBotton: '0px',
    width: 'fit-content',
    textAlign: 'left',
  }; 

  return (
    <div
    >
      <form
        onSubmit={ handleSubmit(onSubmit) }
      >
        <FormProvider {...methods}>

          <h1 className="pb-4">{ t("password.title") }</h1>
          <ControllerInput
            autoComplete="off"
            disabled={ loading }
            label={ t("common.email") }
            message={ errors.email?.message }
            name={ register("email").name }
            placeholder={ t("common.emailExample") }
            control={ methods?.control }
            type="email"
            labelColor='white'
            altErrorStyle={altErrorMessageStyle}
          />
          {loading
            ? (
              <LoaderSpinner />
            ) : (
              <Button
                className="btn mb-0"
                disabled={ loading }
                color="first"
                type="submit"
                name="btn_recover"
              >
                { t("common.continue") }
              </Button>
            )
          }
          <Label className="wantText" color='white'>
            {!loading && <>
              { t("password.wantToLogin") }&nbsp;
              {/* <RouterLink
                className="p-0 col-12"
                to={ routes.login(appOrigin) }
                color="third"
                disabled={ loading }
              >
                { t("login.buttonLogIn") }
              </RouterLink> */}
              <LinkText color='third' onClick={() => setStep(1)}>
                { t("login.buttonLogIn") }
              </LinkText>
            </>}
          </Label>

        </FormProvider>
      </form>
      <SlideCaptchaModal
        isOpen={ isSlideModalOpen }
        onRequestClose={ () => setIsSlideModalOpen(false) }
        onSuccess={ () => onRecover(values)}
      />
    </div>
  )
}

export default AltRecoverPassword